document.addEventListener("DOMContentLoaded", function () {
  const searchInputs = document.querySelectorAll(".search__input");
  const enableRotation = window.placeholderSettings?.enableRotation || true;
  const intervalDuration = window.placeholderSettings?.intervalDuration || 1000;
  const placeholderTexts = window.placeholderSettings?.placeholderTexts || [
    "Teigfäden", "Pistaziencreme", "Kadayif", "Rinderhackfleisch", "Rinderschinken"
  ];

  if (!enableRotation || !searchInputs.length) return;

  let index = 0;

  searchInputs.forEach(input => {
    input.setAttribute("placeholder", placeholderTexts[index]);
  });

  function changePlaceholders() {
    index = (index + 1) % placeholderTexts.length; // Döngü
    searchInputs.forEach(input => {
      input.setAttribute("placeholder", placeholderTexts[index]);
    });
  }

  setInterval(changePlaceholders, intervalDuration);
});
